module.exports = __webpack_public_path__ + "img/BannerMobile.c7abc152.svg";